import React, { Component } from 'react';
import {
    Grid,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    Typography,
    CircularProgress,
    IconButton,
    AppBar,
    Button,
    Tabs,
    Tab
} from '@material-ui/core';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import DeleteSweepIcon from '@material-ui/icons/DeleteSweep';
import { withStyles } from '@material-ui/core/styles';
import { withSnackbar } from 'notistack';
//import { enqueueSnackbar } from 'notistack';
import {
    createPatientGroup, providerRestrictedByAdmin,
    removePatientFromGroup, removeProviderInRestrictMode,
    getAllRestrictedProviders
} from '../../services/api/admin';
import TabPanel from '../../components/TabPanel';
import CreateGroupPatientModal from '../../components/CreateGroupPatientModal';
import CreateProviderRestrictedModal from '../../components/CreateProviderRestrictedModal';
import RemoveGroupPatientModal from '../../components/RemoveGroupPatientModal';
import RemoveProviderModal from '../../components/RemoveProviderModal';
import ProviderMembersList from '../ProviderMembersList';
import ProviderRestrictedSearchBar from '../../components/ProviderRestrictedSearchBar';


class ProviderGroupPatients extends Component {
    state = {
        isLoading: false,
        getProviderInfo: [],
        openGroupModal: false,
        openProviderModal: false,
        openRemovePatientModal: false,
        openRemoveProviderModal: false,
        patients: {},
        pageIndex: 0,
        pageLimit: 20,
        tabPosition: 0,
        practiceId: null,
        restrictedProviderInfo: [],
        providerInfo: {},
        expanded: false,
        providerId: '',
        provider: [],
        search: false,
        searchProviderId: null,
        clearInputBox: false,
        searchClear: null,
        disableButton: false
    }

    async componentDidMount() {
        try {
            await this.fetchProvidersInfo();
        } catch (err) {
            console.log(err);
        } finally {
            this.setState({ isLoading: false });
        }
    }




    handleExpand = (result) => {
        const { providerId } = this.state;
        if (result.id === providerId) {
            this.setState({
                expanded: false,
                providerId: ''
            });
        } else {
            this.setState({
                expanded: true,
                providerId: result.id
            });
        }
    }

    fetchProvidersInfo = async () => {
        const { enqueueSnackbar } = this.props;
        const { practiceId, pageLimit, pageIndex, searchProviderId } = this.state;
        try {
            const getProviderInfo = await getAllRestrictedProviders(practiceId, pageLimit, pageIndex * 20, searchProviderId);
            this.setState({ getProviderInfo: getProviderInfo.data, searchProviderId: null }, () => {
            });
        } catch (err) {
            enqueueSnackbar(
                'Unable to fetch group patients, please try again.'
            );
        }
    };


    onPageForward = async () => {
        const { pageIndex } = this.state;
        this.setState({ pageIndex: pageIndex + 1 }, () => {
            this.fetchProvidersInfo();
        });
    };


    handleProviderToSearch = provider => {
        this.setState({ pageIndex: 0, searchProviderId: provider && provider.id, searchClear: null }, () => {
            this.fetchProvidersInfo();
        });
    }


    onPageBack = async () => {
        const { pageIndex } = this.state;
        const { enqueueSnackbar } = this.props;
        if (pageIndex === 0) {
            enqueueSnackbar('You are on the first page');
        }
        else {
            this.setState({ pageIndex: pageIndex - 1 }, () => {
                this.fetchProvidersInfo();
            });
        }
    };

    onCreateGroup = async () => {
        this.setState({ openGroupModal: true, expanded: false });
    };

    addProviderToRestrictMode = () => {
        this.setState({ openProviderModal: true, expanded: false });
    };

    onCloseModal = () => {
        this.setState({
            openGroupModal: false, openProviderModal: false,
            openRemovePatientModal: false,
            openRemoveProviderModal: false
        });
    }

    onCreatePatientGroup = async groupParams => {
        this.setState({
            disableButton: true
        })
        let uniqueChars = [...new Set(groupParams.patientId)];
        groupParams.patientId = uniqueChars;
        const { enqueueSnackbar } = this.props;
        try {
            const creatGroupRes = await createPatientGroup(groupParams);
            this.setState({ openGroupModal: false, disableButton: false });
            this.fetchProvidersInfo();
            enqueueSnackbar('Patient successfully added', { preventDuplicate: true });
        } catch (err) {
            enqueueSnackbar('Unable to create group. Please try again.', { preventDuplicate: true });
        }
    };

    onProviderRestrict = async params => {
        const { enqueueSnackbar } = this.props;
        try {
            const message = await providerRestrictedByAdmin(params.id);
            if (message.data === 'Already Provider In restrict Mode') {
                enqueueSnackbar('Already Provider In Restrict Mode');
            } else {
                this.fetchProvidersInfo();
                enqueueSnackbar('Provider successfully restricted', { preventDuplicate: true });
                this.setState({ openProviderModal: false });
            }
        } catch (err) {
            enqueueSnackbar('Unable to restricted provider. Please try again.');
        }
    }

    openRemovePatientModal = (params) => {
        this.setState({ openRemovePatientModal: true, patients: params });
    }

    onRemovePatientSubmit = async () => {
        const { enqueueSnackbar } = this.props;
        try {
            await removePatientFromGroup(this.state.patients.id);
            this.fetchProvidersInfo();
            enqueueSnackbar('Patient successfully Removed');
            this.setState({ openRemovePatientModal: false });
        } catch (err) {
            enqueueSnackbar('Unable to remove patient. Please try again.');
        }
    }

    onRemoveProviderSubmit = async () => {
        const { providerInfo, practiceId, searchProviderId } = this.state;
        const { enqueueSnackbar } = this.props;
        try {
            await removeProviderInRestrictMode(providerInfo.id);
            this.fetchProvidersInfo();
            this.setState({
                openRemoveProviderModal: false,
                searchClear: "clear"
            });
            enqueueSnackbar('Provider successfully Removed', { preventDuplicate: true });
        } catch (err) {
            enqueueSnackbar('Unable to remove provider. Please try again.');
        }
    }

    openRemoveProviderModal = (params) => {
        this.setState({
            openRemoveProviderModal: true, providerInfo: params
        });
    }

    handleTabPositionChange = async (event, newTabPosition) => {
        this.setState({ tabPosition: newTabPosition, pageIndex: 0, pageLimit: 20, expanded: false });
        this.fetchProvidersInfo();
    };



    render() {
        const { classes } = this.props;
        const { openRemoveProviderModal, disableButton, tabPosition, pageIndex, pageLimit, getProviderInfo, isLoading, openGroupModal, openProviderModal, openRemovePatientModal } = this.state;
        return (
            isLoading ? (<div className={classes.loading}>
                <CircularProgress />
            </div>) : (
                    <div className={classes.root}>
                        <header className={classes.header}>
                            <Grid container justifyContent="space-between" alignItems="center">
                                <Grid item>
                                    <Typography variant="h2" className={classes.headerText}>
                                        Patients
                                    </Typography>
                                </Grid>
                                <Grid item>
                                    <div className={classes.actions}>
                                        <Button
                                            className={classes.button}
                                            color="primary"
                                            variant="contained"
                                            onClick={this.onCreateGroup}
                                        >
                                            Add Member to Provider Panel
                                        </Button>
                                        <Button
                                            className={classes.button}
                                            color="primary"
                                            variant="contained"
                                            onClick={this.addProviderToRestrictMode}
                                        >
                                            Add Provider to Restrict List
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </header>
                        <ProviderRestrictedSearchBar
                            label="Restricted Provider search"
                            name="toProvider"
                            placeholder="Search for a provider..."
                            onSelect={(p) => this.handleProviderToSearch(p)}
                            className={classes.selectInput}
                            getProviderInfo={this.state.getProviderInfo}
                            searchvalueClear={this.state.searchClear}
                        />
                        <AppBar
                            position="static"
                            color="default"
                            classes={{ root: classes.appBar }}
                        >
                            <Tabs
                                value={tabPosition} onChange={this.handleTabPositionChange}
                            >
                                <Tab label="Patient Grouped List" />
                                <Tab label="Restricted Provider List" />
                            </Tabs>
                        </AppBar>
                        <TabPanel>
                            {isLoading ? (
                                <div className={classes.loading}>
                                    <CircularProgress />
                                </div>
                            ) : (
                                    <Grid item xs={12}>
                                        <Table>
                                            <TableHead>

                                                <TableRow>
                                                    <TableCell>Provider Name</TableCell>
                                                    <TableCell>Provider Email</TableCell>
                                                    <TableCell>Provider PhoneNo</TableCell>
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {getProviderInfo.map(result => (
                                                    <>
                                                        <TableRow key={result.id}>
                                                            <TableCell width="250">{result.fullTitle}</TableCell>
                                                            <TableCell width="250">
                                                                <Grid container alignItems="center">
                                                                    <Grid
                                                                        item
                                                                        xs={12}
                                                                        xl={3}
                                                                    >
                                                                    </Grid>
                                                                    <Grid item xs={12} xl={3}>
                                                                        {result.email}
                                                                    </Grid>
                                                                </Grid>
                                                            </TableCell>
                                                            <TableCell width="250">{result.phoneNumber}</TableCell>
                                                            <TableCell>
                                                                {
                                                                    tabPosition === 0 ? <IconButton aria-label="expand row" size="small" onClick={() => this.handleExpand(result)}>
                                                                        {(this.state.expanded && this.state.providerId && (result.id === this.state.providerId)) ?
                                                                            <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                    </IconButton> :
                                                                        <IconButton
                                                                            //className={classes.marginLeftTen}
                                                                            size="small"
                                                                            aria-label="removePatient"
                                                                            title="removePatient"
                                                                            color="primary"
                                                                            onClick={() => this.openRemoveProviderModal(result)}
                                                                        >
                                                                            <DeleteSweepIcon color="primary" />
                                                                        </IconButton>
                                                                }
                                                            </TableCell>
                                                        </TableRow>
                                                        {tabPosition === 0 && this.state.expanded && this.state.providerId && (result.id === this.state.providerId) ? <TableRow>
                                                            <ProviderMembersList
                                                                providerId={this.state.providerId}
                                                                open={this.state.expanded}
                                                            />
                                                        </TableRow> : null
                                                        }
                                                    </>
                                                ))}
                                            </TableBody>
                                        </Table>

                                        <div className={classes.pageTurners}>
                                            <IconButton disabled={pageIndex === 0}>
                                                <ArrowBackIosIcon
                                                    style={{ opacity: pageIndex === 0 ? '0.5' : '1.0' }}
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={this.onPageBack}
                                                />
                                            </IconButton>
                                            <IconButton disabled={getProviderInfo && getProviderInfo.length < pageLimit}>
                                                <ArrowForwardIosIcon
                                                    style={{ opacity: getProviderInfo.length < pageLimit ? '0.5' : '1.0' }}
                                                    color="primary"
                                                    variant="contained"
                                                    onClick={this.onPageForward}
                                                />
                                            </IconButton>
                                        </div>
                                    </Grid>
                                )}
                        </TabPanel>
                        {openGroupModal &&
                            <CreateGroupPatientModal
                                open={openGroupModal}
                                onClose={this.onCloseModal}
                                save={this.onCreatePatientGroup}
                                disableButton={disableButton}
                            />
                        }
                        {
                            openProviderModal &&
                            <CreateProviderRestrictedModal
                                open={openProviderModal}
                                onClose={this.onCloseModal}
                                save={this.onProviderRestrict}
                            />
                        }
                        {
                            openRemovePatientModal &&
                            <RemoveGroupPatientModal
                                open={openRemovePatientModal}
                                onClose={this.onCloseModal}
                                save={this.onRemovePatientSubmit}
                            />
                        }
                        {
                            openRemoveProviderModal &&
                            <RemoveProviderModal
                                open={openRemoveProviderModal}
                                onClose={this.onCloseModal}
                                save={this.onRemoveProviderSubmit} />
                        }

                    </div>


                )

        );
    }
}


const styles = () => ({
    loading: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    root: {
        padding: '3em',
    },
    list: {
        paddingBottom: '2em',
    },
    actions: {
        textAlign: 'right',
    },
    button: {
        marginLeft: '20px',
    },
    mergeButton: {
        marginLeft: '20px',
        color: 'black',
        backgroundColor: '#FFF6BF',
        '&:hover': {
            marginLeft: '20px',
            color: 'black',
            backgroundColor: '#cdc48d',
        },
    },
    pageTurners: {
        width: '100%',
        marginTop: '5px',
        display: 'flex',
        justifyContent: 'space-between'
    },
    container: {
        padding: '3em',
    },
    appBar: {
        zIndex: 10,
    },
    header: {
        paddingBottom: '3em',
    },
    selectInput: {
        marginTop: '0.5em',
        marginBottom: '1em',
    },
    headerText: {
        fontWeight: 'normal',
        fontSize: '1.8em',
        lineHeight: '19px',
        color: '#1C1C1C',
        paddingBottom: '0.5em',
    },
    helpText: {
        paddingBottom: '0.5em',
    },
    marginLeftAuto: {
        marginLeft: 'auto',
    },
    marginLeftTen: {
        marginLeft: 6,
    },
});

export default withSnackbar(
    withStyles(styles)(ProviderGroupPatients)
);
